import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'

import './shared.css'
import './index.css'
import { getFunnelFromUrl } from '../../lib/funnels/functions/v1/default/getFunnelFromUrl'

document.addEventListener('DOMContentLoaded', () => {
  // -------------------

  const SESSION_ID = 'tdMainFunnel'

  queryParamsToSession(SESSION_ID)

  let under10K = '/eligibility/1/'
  let over10K = '/savings-estimates/submit/?title=consolidation'

  const funnel = getFunnelFromUrl()

  if (funnel === 'qualify') {
    updateSession(SESSION_ID, 'funnel', funnel)
    under10K = '/qualify/one-click/'
    over10K = '/savings-estimates/submit/?title=consolidation&funnel=qualify'
  }

  // @ts-ignore
  window.clickDebtOption = function clickDebtOption(debtAmount) {
    updateSession(SESSION_ID, 'debtOwed', debtAmount)

    if (parseInt(debtAmount) < 10000) {
      window.location.href = under10K
      return
    }

    window.location.href = over10K
  }
})
